<template>
  <van-config-provider :theme-vars="themeVars">
  <div class="van-hairline--surround">
       <van-cell-group inset border="false">
         <h3 style="padding-top: 1em;">西山医院-早知心</h3>
        <p class="textIndentation">早知心，是北京友谊医院、安贞医院等相关领域专家推动，由中国科学院下属中科软创建，面向广泛关注个人心脏健康人群，提供一整套心脏健康管理服务工具。</p>
        <p class="textIndentation">西山医院发起早知心项目，旨在对其体检客户提供个人心脏健康早期风险识别、分析，帮助客户更早优化、改进个人健康状态。</p>
       </van-cell-group>
   </div>
 </van-config-provider>
  <div class="video-container">
    <video id="player-container-id"  width="360" height="220" preload="none" playsinline webkit-playsinline controls autoplay></video>
  </div>
<br/>
<div class="van-hairline--surround">
        <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">项目背景和目标:</van-divider>
       <p class="match">
        <van-notice-bar wrapable :scrollable="false" color="#1989fa" >
          1、项目是由北京友谊、安贞医院专家指导，<strong>基于最新《中国心血管病一级预防指南》建设</strong>，更全面，更科学、更准确的识别心脏早期风险。
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa">
          2、<strong>西山医院发起早知心项目</strong>，旨在对体检客户心脏健康进行早期分析，为每个人提供精准服务。
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa">
          3、<strong>99%的人发病前不知道自己有心脏健康风险。</strong>而如果能够提前预知心脏健康风险，86%的人通过日常生活管理就会降低风险。
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa">
          4、<strong>如果后续考虑在西山医院调理，方案中充分使用医疗保险和企业补充，个人支付占比预计不到5%。</strong>
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa">
          5、此项目是西山医院早知心项目组对客户的线上服务，<strong>分析结果不会同步到体检报告中，也不会未经允许的情况下给到第三方。</strong>
         </van-notice-bar>
         </p>
     </van-cell-group>
   </div>
   <br/>
   <div class="van-hairline--surround">
        <van-cell-group inset>
         <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }" dashed>招募条件:</van-divider>
       <p class="match">
        <van-notice-bar color="#1989fa" wrapable :scrollable="false">
          1、在我院体检套餐中，涵盖血压、血脂、胸部CT检查客户，不存在拒检项。<strong>如果没有血压、血脂、胸部CT检查项目，无法参加此项目。</strong>
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa">
          2、体检检查发在在近4个月，即2023年7月1日之后。
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa">
          3、如果已经明确心脏问题，做过冠脉CTA等检查，无需参与此项目。
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa">
          4、退休人员优先。
         </van-notice-bar>
         </p>
     </van-cell-group>
   </div>
   <br/>
   <div class="van-hairline--surround">
      <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }" dashed>参与方式：</van-divider>
         <p class="match">
          <van-notice-bar color="#EA6853" wrapable :scrollable="false">
            第一步，<strong>微信扫描下面【西山医院早知心邀请码】或微信搜索【早知心】</strong> ，按提示填写个人在<strong>西山医院</strong>留存信息，进行机构绑定。
         </van-notice-bar>
          </p>
        <p class="match">
          <van-notice-bar color="#EA6853" wrapable :scrollable="false">
            第二步，分析会1个小时内完成，您请在<strong>【早知心】-【心脏健康】</strong>查阅，会有短信通知到您，注意查收。
         </van-notice-bar>
          </p>
        </van-cell-group>
   </div>
   <br/>
   <div class="video-container">
    <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }" dashed>【绑定】操作指南视频</van-divider>
    <video id="player-container-id2"  width="360" height="220" preload="none" playsinline webkit-playsinline controls autoplay></video>
  </div>
  <br/>
   <div class="van-hairline--surround">
        <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }" dashed>注意事项与费用:</van-divider>
       <p class="match">
        <van-notice-bar color="#EA6853" wrapable :scrollable="false">
          1、用户需要在西山医院有血压、血脂、胸部CT检查数据，才能参与。
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#EA6853">
          2、西山医院早知心项目试运营期间：<strong>仅需1元即获取一份专属个人深度心脏健康语音分析和调理计划方案。</strong>
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#EA6853">
          3、如果后续在我院门诊继续检查或调理，费用不在此项目中。
         </van-notice-bar>
         </p>
     </van-cell-group>
   </div>
   <br/>
   <div class="van-hairline--surround">
        <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">项目特点一：解决了99%的人发病前毫不知情的问题</van-divider>
         <van-image src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/know.png" />
     </van-cell-group>
   </div>
   <br/>
   <div class="van-hairline--surround">
        <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">项目特点二：自我日常管理,86%的人会将风险控制很好</van-divider>
         <van-image src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/jkguihua.png" />
     </van-cell-group>
   </div>
   <br/>
   <div class="van-hairline--surround">
        <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">项目特点三：充分使用企业支付和医疗保险，个人支付比低</van-divider>
         <van-image src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/zhifu.png" />
     </van-cell-group>
   </div>
   <br/>
   <div class="van-hairline--surround">
      <van-cell-group inset>
        <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }" dashed>现在参与：</van-divider>
        <p class="match">
          <van-notice-bar color="#EA6853" wrapable :scrollable="false">
            <strong>微信扫描下面【西山医院早知心邀请码】或微信搜索【早知心】</strong>，按提示填写个人在<strong>西山医院</strong>留存信息，进行机构绑定。
         </van-notice-bar>
          </p>
         <img class="aligncenter" referrerpolicy="no-referrer"
          src="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQEq8jwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyNVVuREUzRE5kNkUxMDAwMGcwMy0AAgRim5FkAwQAAAAA" />

        </van-cell-group>
         </div>
       <br/>
  <van-config-provider :theme-vars="themeVars2">
      </van-config-provider>
      <div class="van-hairline--surround">
      <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }" dashed>答疑方式</van-divider>
         <p class="match">
          <van-notice-bar color="#EA6853" wrapable :scrollable="false">
            <strong>如果您有任何问题，可以在【早知心】公众号底部留言，我们会及时回复。【9:00-21:00】</strong>
         </van-notice-bar>
          </p>
        </van-cell-group>
   </div>
   <br/>
</template>
<script>
import { reactive, onMounted } from 'vue';
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';
export default {
 setup() {
   const themeVars = reactive({
     cellGroupBackground: '#F1F1F1',
   });
   const kpian = reactive({
     cellGroupBackground: '#AAAAAA',
   });
   const kpianawait = reactive({
     cellGroupBackground: '#F1F1F1',
   });
   const themeVars2 = reactive({
     cellGroupBackground: '#F1F1F1',
   });
   let player = reactive(null)
   let player2 = reactive(null)
   onMounted(() => {
     player = TCPlayer('player-container-id',
       {
         fileID: '3270835011921673782', // 请传入需要播放的视频 fileID（必须）
         appID: '1258265833', // 请传入点播账号的 appID（必须）
         psign: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6MTI1ODI2NTgzMywiZmlsZUlkIjoiMzI3MDgzNTAxMTkyMTY3Mzc4MiIsImN1cnJlbnRUaW1lU3RhbXAiOjE2OTkzMjg1OTAsImNvbnRlbnRJbmZvIjp7ImF1ZGlvVmlkZW9UeXBlIjoiT3JpZ2luYWwifSwidXJsQWNjZXNzSW5mbyI6eyJkb21haW4iOiIxMjU4MjY1ODMzLnZvZDIubXlxY2xvdWQuY29tIiwic2NoZW1lIjoiSFRUUCJ9fQ.arg3A4pKRKaGGWzcLwSkPCGgXw0y96Ym3Q2jSBa6VFY',  
         licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1258265833_1/v_cube.license',
       });
     player2 = TCPlayer('player-container-id2',
       {
         fileID: '3270835012044694673', // 请传入需要播放的视频 fileID（必须）
         appID: '1258265833', // 请传入点播账号的 appID（必须）
         psign: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6MTI1ODI2NTgzMywiZmlsZUlkIjoiMzI3MDgzNTAxMjA0NDY5NDY3MyIsImN1cnJlbnRUaW1lU3RhbXAiOjE2OTk1Njk5OTQsImNvbnRlbnRJbmZvIjp7ImF1ZGlvVmlkZW9UeXBlIjoiT3JpZ2luYWwifSwidXJsQWNjZXNzSW5mbyI6eyJkb21haW4iOiIxMjU4MjY1ODMzLnZvZDIubXlxY2xvdWQuY29tIiwic2NoZW1lIjoiSFRUUCJ9fQ.yF4u-l4kNRJei_nd1AsFyl6mn3rJVxJizq5L7o9sFmw',  
         licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1258265833_1/v_cube.license',
       });
   })
   return {
     //fid,
     player,
     player2,
     themeVars,
     kpian,
     kpianawait,
     themeVars2,
   }
 }
}
</script>
<style scoped>
@import url("//imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css");
#app {
 font-family: Avenir, Helvetica, Arial, sans-serif;
 -webkit-font-smoothing: antialiased;
 -moz-osx-font-smoothing: grayscale;
 text-align: center;
 color: #2c3e50;
}

.textIndentation {
 text-align: left;
 text-indent: 2em;
 font-weight: bold;
 font-size: 14px;
 padding-top: 0em;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
 line-height:20px;
}

.text2Indentation {
 text-align: left;
 text-indent: 2em;
 font-weight: bold;
 font-size: 14px;
 padding-top: 1px;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
}

.match {
 text-align: left;
 text-indent: 1em;
 font-size: 14px;
 color: #2c3e50;
}

.text3Indentation {
 text-align: left;
 font-weight: bold;
 font-size: 14px;
 padding-top: 1em;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
}
.image_6 {
  width: 260px;
  height: 260px;
  margin-left: 16px;
  margin-right: 249px;
}
.video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.video-container {
    position: relative;
    width: 95%;
    margin: 0 auto;
}

.aligncenter {
    width: 300px;
    height: 300px;
    clear: both;
    display: block;
    margin: auto;
}

</style>
